import React from 'react';
import { Box, Typography } from '@mui/material';

const Utilities: React.FC = () => (
  <Box sx={{ color: '#fff', p: 4 }}>
    <Typography variant="h4">Utilities</Typography>
    <Typography sx={{ mt: 2 }}>Utilities page (stub)</Typography>
  </Box>
);

export default Utilities;
